/* eslint-disable no-param-reassign */
import React from 'react';
import { IconButton } from '@one-thd/sui-atomic-components';
import { ArrowBack } from '@one-thd/sui-icons';
import PositionedHeader from '../PositionedHeader';
import { HeaderThdB2bLogo } from './HeaderThdB2bLogo';
import { HeaderB2BQuickAccess } from './HeaderB2BQuickAccess';
import { HeaderNavigationButtons } from '../HeaderNavigationButtons';
import { HeaderStoreAndDelivery } from '../HeaderStoreAndDelivery';
import { HeaderController } from '../HeaderController';
import { HeaderSearch } from '../HeaderSearch';
import { HeaderBarcodeSearch } from '../HeaderBarcodeSearch';
import { CartIcon } from '../CartIcon';
import { AdaptiveUIEventSubscriber } from '../../generic-ui/AdaptiveUIEventSubscriber';
import TopHat from '../TopHat';
import { B2B_NAV_BUTTONS } from '../HeaderNavigationButtonsDictionary';

const HeaderB2b = () => {

  const headerClasses = [
    'sui-flex sui-font-regular sui-items-center',
    'sui-bg-pro sui-text-inverse',
    'sui-px-4 sui-pt-4 sui-pb-12 sui-gap-2',
    'lg:sui-pb-4 lg:sui-gap-6'
  ].join(' ');

  const headerControllerFeatureSwitches = {
    isRecentlyViewedEnabled: true,
    isBuyItAgainPreTypeEnabled: true,
    isBuyItAgainPostTypeEnabled: true
  };

  return (
    <HeaderController
      theme={{ inverseTheme: true }}
      customerType="B2B"
      featureSwitches={headerControllerFeatureSwitches}
      options={{ skipContactCenter: false }}
    >
      <PositionedHeader
        topHatComponent={<TopHat />}
      >
        <HeaderB2BQuickAccess />
        <div className={headerClasses}>
          <AdaptiveUIEventSubscriber
            event="typeahead.suggestions-menu-open-close"
            primaryNode={<HeaderThdB2bLogo />}
            secondaryNode={(
              <IconButton
                data-testid="header-back-arrow-button"
                color="inverse"
                icon={ArrowBack}
                iconSize="regular"
              />
            )}
          />
          <HeaderStoreAndDelivery mobileOnly={false} />
          <HeaderSearch />
          {/* Start of Mobile only components */}
          <AdaptiveUIEventSubscriber
            event="typeahead.suggestions-menu-open-close"
            primaryNode={<CartIcon />}
            secondaryNode={<HeaderBarcodeSearch />}
            mobileOnly
          />
          <HeaderStoreAndDelivery mobileOnly />
          {/* End of Mobile only components */}
          <HeaderNavigationButtons navButtonsData={B2B_NAV_BUTTONS} />
          <AdaptiveUIEventSubscriber
            event="typeahead.suggestions-menu-open-close"
            primaryNode={<CartIcon />}
            secondaryNode={<HeaderBarcodeSearch />}
            mobileOnly={false}
          />
        </div>
      </PositionedHeader>
    </HeaderController>
  );
};

HeaderB2b.displayName = 'HeaderB2b';

export { HeaderB2b };
